export const formType = {
  login: "login",
  requestReset: "",
  reset: "reset",
  join: "join",
  activate: "activate",
  register: "register",
  registered: "registered",
  confirmed: "confirmed",
  info: "info",
  twoFactor: "twoFactor",
};
